import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withKeys as _withKeys, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-371cf2d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  scope: "col"
}
const _hoisted_4 = {
  key: 1,
  scope: "col"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"opacity":"0"} }, "Arrow", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["data-ts", "tabindex", "onClick", "onKeydown"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "table__checkbox" }
const _hoisted_10 = ["data-ts", "value"]
const _hoisted_11 = ["data-ts"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import TableHeader from './TableHeader.vue';
import TableFilters from './TableFilters.vue';
import {
	ColumnInterface,
	TableRowType,
	TableColumnAlignType,
	TableColumnAlignClassType,
	TableSortType,
} from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    columns: {},
    rows: {},
    sortBy: {},
    clickableRows: { type: Boolean },
    selectableRows: { type: Boolean },
    ariaLabel: {},
    expandableRows: { type: Boolean },
    preSelectedRows: {},
    hasTableFilters: { type: Boolean }
  },
  emits: ["clickRow", "clickHeader", "selectedRows"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const selectedRows = ref([]);
const allRowsSelected = ref<boolean>(false);
const moveCol = ref<{ from: number | null; to: number | null }>({ from: null, to: null });
const pageNumber = ref<number>(0);
const pageSize = ref<number>(25);

let headerToResize: HTMLHeadElement | null;
let resizedHeaderWidth = 0;
let mouseX = 0; // Get mouse X for col resizing.

const emit = __emit;

watch(allRowsSelected, (newValue) => {
	selectedRows.value = newValue ? props.rows : [];
});

watch(selectedRows, () => emit('selectedRows', selectedRows.value));

const getColumnClass = (align: TableColumnAlignType | undefined): TableColumnAlignClassType => {
	switch (align) {
		case 'center':
			return 'align-center';
		case 'right':
			return 'align-right';
		default:
			return 'align-left';
	}
};

const getHeaderClass = (colIndex: number) => {
	const check = colIndex === moveCol.value.to && moveCol.value.to !== moveCol.value.from;
	return check ? 'drop-destination' : null;
};

const onMouseMove = (e: MouseEvent) => {
	if (headerToResize) {
		const dx = e.clientX - Number(mouseX);
		headerToResize.style.width = `${Number(resizedHeaderWidth) + dx}px`;
	}
};

const onMouseUp = (): void => {
	document.removeEventListener('mousemove', onMouseMove);
	document.removeEventListener('mouseup', onMouseUp);
};

const onMouseDown = (e: MouseEvent): void => {
	mouseX = e.clientX;
	headerToResize = (e.target as Element).parentElement;

	if (headerToResize) {
		const style = window.getComputedStyle(headerToResize);
		resizedHeaderWidth = parseInt(style.width, 10);

		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp, true);
	}
};

const composedColumns = ref([...props.columns]);

const swapCols = () => {
	if (moveCol.value.from !== null && moveCol.value.to !== null) {
		[composedColumns.value[moveCol.value.from], composedColumns.value[moveCol.value.to]] = [
			composedColumns.value[moveCol.value.to],
			composedColumns.value[moveCol.value.from],
		];
	}
	moveCol.value = { from: null, to: null };
};

/** Logic for expandable columns here */
const expandedRowIndex = ref();

const onExpandRow = (rowIndex: number): void => {
	if (expandedRowIndex.value === rowIndex) {
		expandedRowIndex.value = null;
	} else {
		expandedRowIndex.value = rowIndex;
	}
};

const getPageNumberFromUrl = (): number => {
	const route = useRoute();
	const { query } = route || {};
	const number = query ? query.page : null;
	return number ? Number(number) - 1 : 0;
};

const getPageSizeFromUrl = (): number => {
	const route = useRoute();
	const { query } = route || {};
	const size = query ? query.limit : null;
	return size ? Number(size) : 0;
};

onMounted(() => {
	if (props.preSelectedRows) selectedRows.value = props.preSelectedRows;
	composedColumns.value = [...props.columns];
	composedColumns.value.unshift({ id: 'rowNumber', label: '#' });
	pageNumber.value = getPageNumberFromUrl();
	pageSize.value = getPageSizeFromUrl();
});

watch(
	() => props.preSelectedRows,
	() => {
		selectedRows.value = props.preSelectedRows;
	}
);

const handleFilterColumns = (filteredColumns: Array<{ id: string; label: string }>) => {
	composedColumns.value = filteredColumns;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", {
      class: _normalizeClass(['table', { 'table--no-filters': !_ctx.hasTableFilters }]),
      "data-ts": "table",
      "aria-label": _ctx.ariaLabel || 'data table'
    }, [
      (_ctx.hasTableFilters)
        ? (_openBlock(), _createBlock(TableFilters, {
            key: 0,
            columns: _ctx.columns,
            "aria-label": _ctx.ariaLabel,
            onUpdateColumns: handleFilterColumns
          }, null, 8, ["columns", "aria-label"]))
        : _createCommentVNode("", true),
      _createElementVNode("thead", {
        class: _normalizeClass({ 'head--no-filters': !_ctx.hasTableFilters })
      }, [
        _createElementVNode("tr", null, [
          (_ctx.selectableRows)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allRowsSelected).value = $event)),
                    "data-ts": "select-all-checkbox",
                    class: "table__checkbox",
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, allRowsSelected.value]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composedColumns.value, (column, idx) => {
            return (_openBlock(), _createBlock(TableHeader, {
              key: `col-head-${column.id}`,
              column: column,
              "data-ts": `table-cell-${column.id}`,
              class: _normalizeClass([getColumnClass(column.align), getHeaderClass(idx)]),
              idx: idx,
              "sort-by": _ctx.sortBy,
              onMoveFrom: _cache[1] || (_cache[1] = (fromIndex) => (moveCol.value.from = fromIndex)),
              onMoveTo: _cache[2] || (_cache[2] = (toIndex) => (moveCol.value.to = toIndex)),
              onSwapCols: swapCols,
              onClickHeader: ($event: any) => (_ctx.$emit('clickHeader', column)),
              onResizeColumn: onMouseDown
            }, null, 8, ["column", "data-ts", "class", "idx", "sort-by", "onClickHeader"]))
          }), 128)),
          (_ctx.expandableRows)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `row-${rowIndex}`
          }, [
            _createElementVNode("tr", {
              "data-ts": `table-row-${rowIndex}`,
              class: _normalizeClass([
							'table__row',
							{
								'table__row--clickable':
									_ctx.clickableRows || (_ctx.expandableRows && row.subRows.length),
							},
							{ 'table__row--expanded': rowIndex === expandedRowIndex.value },
						]),
              tabindex: _ctx.clickableRows ? 0 : undefined,
              onClick: ($event: any) => (
							(_ctx.clickableRows && _ctx.$emit('clickRow', row)) ||
								(_ctx.expandableRows && row.subRows.length && onExpandRow(rowIndex))
						),
              onKeydown: _withKeys(($event: any) => (_ctx.clickableRows && _ctx.$emit('clickRow', row)), ["enter"])
            }, [
              (_ctx.selectableRows)
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRows).value = $event)),
                        "data-ts": `row-${rowIndex}-checkbox`,
                        type: "checkbox",
                        value: row,
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, _hoisted_10), [
                        [_vModelCheckbox, selectedRows.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composedColumns.value, (column, idx) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `column-body-${idx}`,
                  "data-ts": `table-cell-${rowIndex}-${column.id}`,
                  class: _normalizeClass(["table__row__data", [getColumnClass(column.align), column.class]])
                }, [
                  _renderSlot(_ctx.$slots, column.id, { data: row }, () => [
                    (column.id === 'rowNumber')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(pageNumber.value * pageSize.value + rowIndex + 1), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row[column.id] ?? '-'), 1))
                  ])
                ], 10, _hoisted_11))
              }), 128)),
              (_ctx.expandableRows)
                ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                    (row.subRows.length)
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 0,
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          class: _normalizeClass({ 'rotate-180': rowIndex === expandedRowIndex.value })
                        }, _hoisted_16, 2))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17))
                  ]))
                : _createCommentVNode("", true)
            ], 42, _hoisted_7),
            (expandedRowIndex.value === rowIndex)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.subRows, (subRow, subRowIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `subRow-${subRowIndex}`,
                    class: "table__sub-row"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(composedColumns.value, (column, idx) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: `sub-col-${idx}`,
                        class: _normalizeClass(["table__row__data", getColumnClass(column.align)])
                      }, [
                        _renderSlot(_ctx.$slots, column.id, {
                          data: { ...subRow, isSubRow: true }
                        }, () => [
                          _createTextVNode(_toDisplayString(subRow[column.id] ?? '-'), 1)
                        ])
                      ], 2))
                    }), 128)),
                    _hoisted_18
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 10, _hoisted_2)
  ]))
}
}

})